import React from 'react'
import { translate } from 'react-polyglot'
import { Field, reduxForm } from 'redux-form'

import { required, email } from 'utils/validation'

import { Form, Button, Notice, Text } from 'components'
import { Email } from 'components/FormField'

const ForgotPasswordForm = ({ handleSubmit, submitting, error, t }) => {
	return (
		<div className="u-center-inside-flex u-max-width--small">
			<Form
				onSubmit={handleSubmit}
				actions={
					<Button
						layout="secondary"
						fullWidth
						centerContent
						text={t('reset_password')}
						type="submit"
						disabled={submitting}
					/>
				}
				error={error}
			>
				<>
					<h1>
						{t('forgot_password')}
						<Text size="small">
							{t('forgot_password_text')}
						</Text>
					</h1>
					<Field
						name="email"
						label={t('forms.email')}
						component={Email}
						validate={[required, email]}
						disabled={submitting}
					/>
				</>
			</Form>
		</div>
	)
}

export default reduxForm({
	form: 'forgotPassword',
})(translate()(ForgotPasswordForm))
